export * from './como-funciona-sorteio/como-funciona-sorteio.component';
export * from './home-sorteios/home-sorteios.component';
export * from './relacao-ganhadores/relacao-ganhadores.component';
export * from './pontuacao/pontuacao.component';
export * from './sorteios.component';
export * from './lista-bilhete-participante/lista-bilhete-participante.component';
export * from './listar-sorteio/listar-sorteio.component';
export * from './shared/sorteio.service';



// WEBPACK FOOTER //
// ./src/app/publico/sorteios/index.ts